















import { Vue, Component } from 'vue-property-decorator'
import { getSupplyChart } from '../../../utils'
import { supplyEnum } from '../utils'
import { SupplyChart } from '@/types/newPersion'
import { PonitXYInside } from '@/types/common/g2Charts'
import InsideBarChart from '@/components/g2Charts/chartList/insideBarChart'
import TsTable from '@/components/TsTable/TsTable.vue'
import Gap from '@/views/newPension/components/gap/index.vue'
@Component({
  components: { InsideBarChart, TsTable, Gap },
})
export default class extends Vue {
  //  @Prop({ default: false }) propTableShow!: boolean
  form = {};
  // btnList = optBtnList;
  // BaseBarCfg
  chartOptions = {
    position: [],
    legendPosition: 'top',
    titleNextContent: '岁',
    stackContent: '',
    valueNextContent: '(元/月)'
    // annotationContent: '单位:元',
  };

  chartData: PonitXYInside[] = [];

  mounted () {
    this.getData()
  }

  private async getData () {
    const res = await await getSupplyChart()
    console.log(121, res, 2)
    const _chartData: PonitXYInside[] = []
    const { pensionSupplies, averageAmount, totalAmount } = res
    this.form = {
      averageAmount, totalAmount
    }
    pensionSupplies.forEach((item: SupplyChart) => {
      for (const k in item) {
        if (k !== 'age') {
          _chartData.push({
            x: item.age + '',
            y: item[k],
            type: supplyEnum[k]
          })
        }
      }
    })
    this.chartData = _chartData
  }

  // private toPage (item: BtnList) {
  //   if (item.path) {
  //     if (this.$route.path === item.path) {
  //       this.$emit('on-click', 'input')
  //     } else {
  //       this.$router.push(item.path)
  //     }
  //   } else {
  //     this.$message({ type: 'success', message: '业务开发中' })
  //   }
  // }
}
